import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';

@Component({
  selector: 'app-list-resume',
  templateUrl: './list-resume.component.html',
  styleUrls: ['./list-resume.component.scss']
})

export class ListResumeComponent implements AfterViewInit {
  isUpdateOperation = false;
  constructor(public authService: AuthenticationService) {}

  ngAfterViewInit() {}
}
